import './ContentBuilderTemplate.scss';
import './ContentBuilderTemplate43.scss';
import React from 'react';
import { usePropsHandler } from '../../EventInterceptor/usePropsHandler';
import { cn } from '../../../utils/bem';
import { cnContentBuilderTemplate } from './index';
import { Typography } from '@dataartdev/uikit/Typography';
import { Grid, GridItem } from '@dataartdev/uikit/Grid';
import { IRoot43 } from './models/CTI_43.props';
import { FeaturedCard } from '../../FeaturedCard/FeaturedCard';

const cnCardBentoBlock = cn('CardBentoBlock');

export const ContentBuilderTemplate: React.FC<IRoot43> = props => {
  const {
    type,
    // title,
    // case: _case,
    // newCaseBadge,
    // author,
    // quote,
    // externalCase,
    contentId,
    // id,
  } = usePropsHandler(cnContentBuilderTemplate(), props);

  const typeNumber = type.toString();

  return (
    <div
      className={cnContentBuilderTemplate({ type: typeNumber })}
      id={contentId}
    >
      <div className={cnCardBentoBlock()}>
        <Grid
          breakpoints={{
            desktop: { cols: 12 },
            tablet: { cols: 12 },
            mobile: { cols: 12 },
          }}
        >
          <GridItem
            breakpoints={{
              desktop: { col: 8 },
              tablet: { col: 10 },
              mobile: { col: 12 },
            }}
          >
            <Typography.Title size="lg" as="h2">
              Section Title
            </Typography.Title>
          </GridItem>
        </Grid>
        <Grid
          breakpoints={{
            desktop: { cols: 12, gap: 'xl' },
            tablet: { cols: 12, gap: 'xl' },
            mobile: { cols: 12, gap: 'xl' },
          }}
          className={cnCardBentoBlock('List')}
        >
          <GridItem
            breakpoints={{
              desktop: { col: 3 },
              tablet: { col: 6 },
              mobile: { col: 12 },
            }}
            className={cnCardBentoBlock('Item')}
          >
            {/*<FeaturedCard />*/}
          </GridItem>
          <GridItem
            breakpoints={{
              desktop: { col: 3 },
              tablet: { col: 6 },
              mobile: { col: 12 },
            }}
            className={cnCardBentoBlock('Item')}
          >
            {/* <FeaturedCard /> */}
          </GridItem>
          <GridItem
            breakpoints={{
              desktop: { col: 3 },
              tablet: { col: 6 },
              mobile: { col: 12 },
            }}
            className={cnCardBentoBlock('Item')}
          >
            {/* <FeaturedCard /> */}
          </GridItem>
          <GridItem
            breakpoints={{
              desktop: { col: 3 },
              tablet: { col: 6 },
              mobile: { col: 12 },
            }}
            className={cnCardBentoBlock('Item')}
          >
            {/* <FeaturedCard /> */}
          </GridItem>
          <GridItem
            breakpoints={{
              desktop: { col: 6 },
              tablet: { col: 12 },
              mobile: { col: 12 },
            }}
            className={cnCardBentoBlock('Item')}
          >
            {/* <TestimonialCard /> */}
          </GridItem>
          <GridItem
            breakpoints={{
              desktop: { col: 3 },
              tablet: { col: 6 },
              mobile: { col: 12 },
            }}
            className={cnCardBentoBlock('Item')}
          >
            {/* <EventCard /> */}
          </GridItem>
          <GridItem
            breakpoints={{
              desktop: { col: 3 },
              tablet: { col: 6 },
              mobile: { col: 12 },
            }}
            className={cnCardBentoBlock('Item')}
          >
            {/* <VideoCard /> */}
          </GridItem>
        </Grid>
      </div>
    </div>
  );
};

export default ContentBuilderTemplate;
